module.exports = __webpack_public_path__ + "img/sync.6440f0bb.svg";